import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next';
import { motion } from "framer-motion";
import { isMobileContext } from '../context/isMobileContext';


const MissionVision = ({strategyPage}) => {
	const { isMobile } = useContext(isMobileContext);
  const { t } = useTranslation();

  return (
    <div className='MissionVision'>
      <div className="img-overlay">
        <img src={process.env.PUBLIC_URL + "/imgs/strategy/subtract.png"} alt="" />
      </div>
      <div className="img-container">
        <img src={process.env.PUBLIC_URL + "/imgs/strategy/mission-img.svg"} alt="" />
      </div>
      <div className="MissionVision-container">
        <div className="MissionVision">
          <div  
            className="header"
          >
            <div  
              className="title-container"
            >
              <motion.h2 
              initial={{ opacity: 0, translateY: "100%" }}
              whileInView={{ opacity: 1, translateY: 0 }}
              viewport={{ once: true }}
              transition={{ ease: "easeInOut", delay: isMobile ? 0.2 : 0.2, duration: 0.5 }}
              className='title1'>
                {t("MissionVision.headLine1")}
              </motion.h2>
            </div>
          </div>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ ease: "easeInOut", delay: isMobile ? 0.75 : 0.5, duration: 0.5 }}>
           {t("MissionVision.description1")} 
          </motion.p>
         </div>
      </div>
      <div className="MissionVision-container second-title">
        <div className="MissionVision">
          <div  
            className="header"
          >
            <div  
              className="title-container"
            >
              <motion.h2 
              initial={{ opacity: 0, translateY: "100%" }}
              whileInView={{ opacity: 1, translateY: 0 }}
              viewport={{ once: true }}
              transition={{ ease: "easeInOut", delay: isMobile ? 0.2 : 0.2, duration: 0.5 }}
              className='title1'>
                {t("MissionVision.headLine2")}
              </motion.h2>
            </div>
          </div>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ ease: "easeInOut", delay: isMobile ? 0.75 : 0.5, duration: 0.5 }}>
           {t("MissionVision.description2")} 
          </motion.p>
         </div>
      </div>
    </div>
  )
}

export default MissionVision